import { AbstractSearchCriteria } from './abstract-search-criteria';

export class KeyControlAndAbstractSearchCriteria extends AbstractSearchCriteria{
    kcCompany = '';
    kcDivision = '';
    kcBrand = '';
    kcDistributionChannel = '';
}
